import { InspectorContext } from "../reducer";
import { useContext } from "react";

export function useAcceptRejectAll() {
  const { state, updateState } = useContext(InspectorContext);

  function acceptAll() {
    const inspections = [...state.inspections];
    inspections.forEach((x) => (x.accept = true));
    updateState({
      type: "Inspections",
      payload: inspections,
    });
  }

  function rejectAll() {
    const inspections = [...state.inspections];
    inspections.forEach((x) => (x.accept = false));
    updateState({
      type: "Inspections",
      payload: inspections,
    });
  }

  return { acceptAll, rejectAll };
}
